// UI labels for «صدمات الطفولة». Course text never lives here — it comes from the server.
export const TRAUMA_UI = {
  discoverHeading: "شو بتتعلّم",
  facts: "16 سؤالاً · 8 دروس",
  start: "بدء الدورة",
  previewBanner: "معاينة — غير منشور بعد",
  bundleTitle: "باقة صدمات الطفولة — 12 دورة",
  catalogTitle: "دورات صدمات الطفولة — د. سارة النحّاس",
  adminTitle: "دورات صدمات الطفولة",
  adminHiddenNote: "هذه الدورات مخفية عن الزوار حتى الإطلاق، وتظهر لك أنت كمسؤول للمعاينة فقط.",
  adminOpenCatalog: "فتح صفحة الدورات",
  usd: "$",
} as const;

export const TRAUMA_BUY_UI = {
  buyCourse: "شراء الدورة",
  buyBundle: "شراء الباقة",
  bundleCount: "12 دورة",
  ownedBadge: "عندك",
  ownedCourse: "الدورة عندك",
  ownedBundle: "الباقة عندك",
  myCourses: "فتح دوراتي",
  review: "منراجع الإيصال، وبعدها منبعتلك رابط الدخول على واتساب.",
  receipt: "إيصال الدفع (صورة أو PDF، حتى 5MB)",
} as const;

export const TRAUMA_RESULT_UI = {
  firstStep: "خطوتك الأولى",
  highlights: "محاور تستحق انتباهك",
  readLesson: "قراءة الدرس",
  readAll: "قراءة كل الدروس",
  whatNext: "شو الخطوة الجاية؟",
  bookLine: "جلسة خاصة مع د. سارة تنطلق من نتيجتك.",
  shareLine: "إرسال الدورة لأهل ممكن يحتاجوها.",
  levelMeter: "مستوى النتيجة",
  book: "حجز استشارة",
  nextCourse: "الدورة الجاية",
  start: "بدء الدورة",
  discover: "التعرّف على الدورة",
  share: "مشاركة الدورة على واتساب",
  previous: "نتيجتك السابقة",
  retake: "إعادة الاختبار",
  myCourses: "دوراتي",
  resultTitle: "نتيجة الدورة",
  lessonsTitle: "دروس الدورة",
  retryError: "ما قدرنا نبدأ الاختبار. منجرّب كمان مرة؟",
} as const;

// Player labels (step 4). Course text never lives here.
export const TRAUMA_PLAYER_UI = {
  start: "بدء",
  resume: "متابعة",
  next: "التالي",
  back: "السابق",
  continue: "متابعة",
  showResult: "عرض النتيجة",
  axisOf: (n: number) => `المحور ${n} من 8`,
  axisTitle: (n: number, label: string) => `المحور ${n}: ${label}`,
  lesson: "الدرس",
  research: "ربط بحثي",
  readyPhrases: "جمل جاهزة",
  repairSteps: "خطوات الترميم",
  copy: "نسخ",
  copied: "تم النسخ",
  openPlayer: "فتح المشغّل",
  openCoursePage: "صفحة الدورة",
  progressLabel: "تقدّم المحاور",
  saveError: "ما قدرنا نحفظ الإجابة. منجرّب كمان مرة؟",
  exit: "خروج",
  axisStatus: (n: number) => `المحور ${n} من 8 · تقدّمك محفوظ`,
  axisChip: (n: number) => `المحور ${n}`,
  questionOf: (i: number) => `سؤال ${i} من 2`,
  lessonHeader: "درس هذا المحور",
  nextAxis: "المحور الجاي",
  prevAxis: "المحور السابق",
  pickHint: "الإجابة الأقرب لك",
  courseOf: (n: number) => `الدورة ${n} من 12`,
  chipAxes: "8 محاور",
  chipQuestions: "16 سؤالاً",
  chipLessons: "8 دروس",
  letterFrom: "رسالة من د. سارة",
  aboutSeries: "عن هذه السلسلة",
  resumeFrom: (n: number) => `متابعة من المحور ${n}`,
  saraName: "د. سارة النحّاس",
  saving: "جارٍ الحفظ",
  axesIndex: "محاور الدورة",
  startCourse: "بدء الدورة",
  autosave: "تقدّمك يُحفظ تلقائياً",
  exitSaved: "خروج — تقدّمك محفوظ",
  courseProgress: "تقدّم الدورة",
  nearestHint: "الإجابة الأقرب لك",
  lessonOf: (n: number) => `درس المحور ${n}`,
  chipShortLessons: "8 دروس قصيرة",
  nextLesson: "الدرس الجاي",
  backToResult: "رجوع لنتيجتك",
} as const;

// Result page (prototype docs/design/trauma-player-prototype.html).
export const TRAUMA_RESULT_PAGE_UI = {
  eyebrow: "نتيجتك",
  ofSixteen: "من 16",
  safeProgress: "الإجابات الأكثر أماناً من 16",
  bookTitle: "بدّكم تحكوا عن النتيجة مع د. سارة؟",
  gaugeCaption: (t: number) => `مجموعك ${t} من 32 · كل ما قلّ المجموع، كانت استجاباتك أكثر أماناً`,
  gaugeAria: (t: number, level: string) => `مجموعك ${t} من 32، ضمن ${level}`,
  numbersTitle: "إجاباتك بالأرقام",
  safeHeadline: "إجابة كانت الاستجابة الأكثر أماناً",
  stackAria: (s: number, g: number, a: number) => `${s} آمنة، ${g} رمادية، ${a} تحتاج انتباه`,
  outOf16: "/ 16",
  categories: ["استجابة آمنة", "منطقة رمادية", "تحتاج انتباه"] as const,
  axesMap: "خريطة المحاور",
  axesMapSub: "إجابتا كل محور. الضغط على أي محور بيفتح مراجعته.",
  axisN: (n: number) => `المحور ${n}`,
  flagAttention: "يستحق انتباهك",
  flagStrength: "نقطة قوة",
  highlightsHeading: (count: number) => (count === 1 ? "محور يستحق انتباهك" : "محوران يستحقان انتباهك"),
  strongPrefix: "كانت إجاباتك كلها آمنة في",
  inAxes: (n: number) => (n === 1 ? "محور واحد" : n === 2 ? "محورين" : `${n} محاور`),
  reviewTitle: "مراجعة الإجابات",
  reviewSub: "ما في إجابة صح وإجابة غلط، بس في استجابة أكثر أماناً لطفلك.",
  filterAria: "تصفية الإجابات",
  filterReview: (n: number) => `تستحق المراجعة (${n})`,
  filterAll: "الكل (16)",
  questionMeta: (n: number, label: string) => `سؤال ${n} · ${label}`,
  yourAnswer: (cat: string) => `إجابتك · ${cat}`,
  safest: "الاستجابة الأكثر أماناً",
  pickedSafest: "اخترت الاستجابة الأكثر أماناً",
  nextCourseOf: (n: number) => `الدورة الجاية · ${n} من 12`,
} as const;

// «دوراتي» portal page (step 7). Course text never lives here.
export const TRAUMA_COURSES_UI = {
  title: "دوراتي",
  start: "بدء الدورة ←",
  resume: "متابعة ←",
  progress: (answered: number) => `${answered} من 16`,
  lastResult: "آخر نتيجة",
  viewResult: "عرض النتيجة",
  readLessons: "قراءة الدروس",
  retake: "إعادة الاختبار",
  empty: "لسّا ما في دورات بحسابك. فيك تتعرّف عليها من صفحة الدورات.",
  browse: "تصفّح الدورات",
  retryError: "ما قدرنا نبدأ الاختبار. منجرّب كمان مرة؟",
} as const;
